import { render, staticRenderFns } from "./arancel.vue?vue&type=template&id=785b97f8&lang=html&"
import script from "./arancel.vue?vue&type=script&lang=js&"
export * from "./arancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports